import React, { useState, useEffect, useRef } from 'react';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import { filterText, trackEvent } from '../helpers/comman';

const features = [
    {
        title: 'Conversational Checkout',
        description: 'Let customers complete purchases right inside the chat—no redirects, no drop-offs, just seamless buying.',
        icon: (
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="24" fill="#3B82F6" fillOpacity="0.1" />
                <circle cx="32" cy="32" r="24" stroke="#06B6D4" strokeWidth="2" />
                <path
                    d="M22 24h20a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H28l-8 5v-5h-2a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4z"
                    fill="#06B6D4"
                />
                <circle cx="28" cy="30" r="2" fill="white" />
                <circle cx="36" cy="30" r="2" fill="white" />
                <circle cx="32" cy="36" r="2" fill="white" />
            </svg>
        )
    },
    {
        title: 'Built-in Upsell Engine',
        description: 'Smartly recommends add-ons and related products during the journey to increase order value effortlessly.',
        icon: (
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="24" fill="#3B82F6" fillOpacity="0.1" />
                <circle cx="32" cy="32" r="24" stroke="#06B6D4" strokeWidth="2" />

                <polyline
                    points="18 38 26 30 34 34 42 22 46 26"
                    stroke="#06B6D4"
                    strokeWidth="3"
                    strokeLinejoin="round"
                    fill="none"
                />

                <circle cx="18" cy="38" r="3" fill="#06B6D4" />
                <circle cx="26" cy="30" r="3" fill="#06B6D4" />
                <circle cx="34" cy="34" r="3" fill="#06B6D4" />
                <circle cx="42" cy="22" r="3" fill="#06B6D4" />
                <circle cx="46" cy="26" r="3" fill="#06B6D4" />
            </svg>

        )
    },
    {
        title: 'Instant Customer Support',
        description: 'Handles FAQs, issues, and ticket creation instantly—reducing support load while delighting customers.',
        icon: (
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="24" fill="#3B82F6" fillOpacity="0.1" />
                <circle cx="32" cy="32" r="24" stroke="#06B6D4" strokeWidth="2" />

                <circle cx="32" cy="24" r="8" stroke="#06B6D4" strokeWidth="2" fill="none" />

                <path
                    d="M24 40c0-4 16-4 16 0v6H24v-6z"
                    fill="#06B6D4"
                />

                <path
                    d="M24 24a8 8 0 0 1 16 0"
                    stroke="#06B6D4"
                    strokeWidth="2"
                    fill="none"
                />

                <path
                    d="M40 28c2 4-4 8-4 8"
                    stroke="#06B6D4"
                    strokeWidth="2"
                    strokeLinecap="round"
                    fill="none"
                />

                <circle cx="36" cy="36" r="2" fill="#06B6D4" />
            </svg>


        )
    },
    {
        title: 'Built-In Payment Orchestration',
        description: 'Connect, route, and optimize across 40+ PSPs—maximizing success rates and giving you total flexibility.',
        icon: (
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="24" fill="#3B82F6" fillOpacity="0.1" />
                <circle cx="32" cy="32" r="24" stroke="#06B6D4" strokeWidth="2" />

                <circle cx="32" cy="32" r="6" fill="#06B6D4" />

                <circle cx="20" cy="20" r="4" fill="#06B6D4" />
                <circle cx="44" cy="20" r="4" fill="#06B6D4" />
                <circle cx="20" cy="44" r="4" fill="#06B6D4" />
                <circle cx="44" cy="44" r="4" fill="#06B6D4" />

                <line x1="32" y1="32" x2="20" y2="20" stroke="#06B6D4" strokeWidth="2" />
                <line x1="32" y1="32" x2="44" y2="20" stroke="#06B6D4" strokeWidth="2" />
                <line x1="32" y1="32" x2="20" y2="44" stroke="#06B6D4" strokeWidth="2" />
                <line x1="32" y1="32" x2="44" y2="44" stroke="#06B6D4" strokeWidth="2" />
            </svg>

        )
    },
    {
        title: 'Platform Agnostic',
        description: 'Works flawlessly with Shopify, WooCommerce, Magento, BigCommerce, and more—no matter your tech stack.',
        icon: (
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="24" fill="#3B82F6" fillOpacity="0.1" />
                <circle cx="32" cy="32" r="24" stroke="#06B6D4" strokeWidth="2" />
                <rect x="18" y="22" width="28" height="18" rx="2" ry="2" stroke="#06B6D4" strokeWidth="2" fill="none" />
                <path d="M18 22l-6-8" stroke="#06B6D4" strokeWidth="2" strokeLinecap="round" />
                <circle cx="24" cy="44" r="3" stroke="#06B6D4" strokeWidth="2" fill="none" />
                <circle cx="42" cy="44" r="3" stroke="#06B6D4" strokeWidth="2" fill="none" />
            </svg>
        )
    },
    {
        title: 'Plug & Play Setup',
        description: 'Launch in minutes with zero dev effort. Nivritti integrates instantly and fits right into your workflow.',
        icon: (
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="24" fill="#3B82F6" fillOpacity="0.1" />
                <circle cx="32" cy="32" r="24" stroke="#06B6D4" strokeWidth="2" />
                <rect x="24" y="20" width="16" height="24" rx="4" ry="4" fill="#06B6D4" />
                <rect x="27" y="12" width="4" height="12" fill="#06B6D4" />
                <rect x="33" y="12" width="4" height="12" fill="#06B6D4" />
                <path
                    d="M24 44h-8a4 4 0 0 1 0-8h8"
                    stroke="#06B6D4"
                    strokeWidth="2"
                    strokeLinecap="round"
                    fill="none"
                />
            </svg>

        )
    }
];

const Features = () => {
    const [showRightArrow, setShowRightArrow] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;

        const handleResize = () => {
            setShowRightArrow(container && container.scrollWidth > container.clientWidth && window.innerWidth < 768);
            setShowLeftArrow(container && container.scrollLeft > 0 && container.scrollWidth > container.clientWidth && window.innerWidth < 768);
        };

        const handleScroll = () => {
            if (container) {
                const isScrollable = container.scrollWidth > container.clientWidth && window.innerWidth < 768;
                setShowLeftArrow(isScrollable && container.scrollLeft > 0);
                setShowRightArrow(isScrollable && container.scrollLeft < container.scrollWidth - container.clientWidth - 1);
            }
        };

        handleResize();
        handleScroll();

        window.addEventListener('resize', handleResize);
        container?.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('resize', handleResize);
            container?.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <section className="bg-black py-28 px-4 sm:px-6 lg:px-8 relative" id='features'>
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-24">
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                        Fintech Infra build for Agentic Payments
                    </h2>
                    <p className="text-xl text-blue-200 max-w-3xl mx-auto">
                        Transform your customer's experience with intelligent payments
                    </p>
                </div>

                <div className="relative">
                    {showLeftArrow && (
                        <button
                            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-blue-600/80 rounded-full p-3 text-white hover:bg-blue-500 transition-all md:hidden shadow-lg hover:scale-110"
                            onClick={() => containerRef.current.scrollBy({ left: -300, behavior: 'smooth' })}
                        >
                            <FaChevronLeft size={24} />
                        </button>
                    )}

                    <div
                        ref={containerRef}
                        className="overflow-x-auto scroll-smooth no-scrollbar py-4 px-2"
                    >
                        <div className="flex gap-8 w-max mx-auto md:w-full md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 md:gap-8">
                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    onClick={() => trackEvent("btn_feature_card_clicked__" + filterText(feature.title))}
                                    className="group relative flex flex-col items-center text-center flex-shrink-0 w-[360px] h-[420px] md:w-full md:h-auto transition-transform duration-300 hover:scale-[102%]"
                                >
                                    {/* Card Border with Hover Animation */}
                                    <div className="absolute inset-0 border-2 border-white/20 rounded-xl group-hover:border-cyan-300/50 transition-all duration-300 group-hover:skew-y-1 group-hover:rotate-1 origin-center">
                                        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/10 to-blue-900/30 backdrop-blur-sm rounded-xl transition-all duration-300 group-hover:bg-blue-900/20" />
                                        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:via-cyan-300/50 transition-all" />
                                        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:via-cyan-300/50 transition-all" />
                                        <div className="absolute left-3 top-3 w-2 h-2 border-t border-l border-white/30 group-hover:border-cyan-300 transition-all"></div>
                                        <div className="absolute right-3 top-3 w-2 h-2 border-t border-r border-white/30 group-hover:border-cyan-300 transition-all"></div>
                                        <div className="absolute left-3 bottom-3 w-2 h-2 border-b border-l border-white/30 group-hover:border-cyan-300 transition-all"></div>
                                        <div className="absolute right-3 bottom-3 w-2 h-2 border-b border-r border-white/30 group-hover:border-cyan-300 transition-all"></div>
                                    </div>

                                    {/* Card Content */}
                                    <div className="relative z-10 p-10 h-full flex flex-col items-center justify-between">
                                        <div className="flex flex-col items-center">
                                            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 mb-10 w-20 h-20 flex items-center justify-center border border-white/10 group-hover:border-cyan-300/30 group-hover:bg-white/10 transition-all duration-300">
                                                <div className="w-12 h-12 transition-transform duration-300 group-hover:scale-110">
                                                    {feature.icon}
                                                </div>
                                            </div>
                                            <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-cyan-300 transition-colors duration-300">
                                                {feature.title}
                                            </h3>
                                            <p className="text-blue-100 text-lg group-hover:text-blue-50 transition-colors duration-300">
                                                {feature.description}
                                            </p>
                                        </div>
                                        <a href="#" onClick={() => trackEvent("btn_feature_card_learn_more_clicked__" + filterText(feature.title))} className="text-white font-medium mt-8 hover:text-cyan-300 transition-colors duration-300 flex items-center group">
                                            Learn more <span className="ml-2 group-hover:translate-x-2 transition-transform duration-300">→</span>
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {showRightArrow && (
                        <button
                            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-blue-600/80 rounded-full p-3 text-white hover:bg-blue-500 transition-all md:hidden shadow-lg hover:scale-110"
                            onClick={() => containerRef.current.scrollBy({ left: 300, behavior: 'smooth' })}
                        >
                            <FaChevronRight size={24} />
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Features;